import React, { useState } from 'react';
import '../styles/FAQ.css';

const faqData = [
  {
    question: "What is SHADE?",
    answer:
      'SHADE stands for "SHare A riDE" — a modern ride-sharing platform that connects riders with nearby drivers for efficient and convenient travel.'
  },
  {
    question: "What is ride sharing or bikepooling?",
    answer:
      "Ride sharing, also known as bikepooling, allows individuals to share rides with others heading in the same direction. Passengers contribute to the travel cost, making the journey economical and eco-friendly."
  },
  {
    question: "How does SHADE work?",
    answer:
      'SHADE operates through a secure mobile application that connects riders and drivers. Simply install the app, and you\'re ready to request or offer a ride.'
  },
  {
    question: "How secure is the application?",
    answer:
      "SHADE is monitored 24/7 by our dedicated support team. The app includes safety features such as real-time location sharing to ensure a secure travel experience."
  },
  {
    question: "What are the benefits of using SHADE?",
    answer:
      "SHADE helps users save money on travel, enjoy a more comfortable commuting experience, and avoid the hassles of public transportation delays."
  }
];

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className="faq-body">
      <h1>FAQs</h1>
      <div className="wrapper">
        {faqData.map((item, index) => (
          <div className="container" key={index}>
            <div
              className={`question ${activeIndex === index ? 'active' : ''}`}
              onClick={() => toggleFAQ(index)}
            >
              {item.question}
            </div>
            <div
              className="answercont"
              style={{
                maxHeight: activeIndex === index ? '500px' : '0'
              }}
            >
              <div className="answer">{item.answer}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
